import { captureException } from '../ygdrasil/libs/SentryHelperDeprecated'
import eventEmitter, { Events } from '../ygdrasil/libs/EventEmitter'

export const captureAndNotifyError = (err: Error) => {
  captureException(err)
  eventEmitter.emit(Events.NEW_SERVER_ERROR)
}
